/* eslint-disable
    no-undef,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('underscore');
const Auth = require('app/scripts/db/auth');
const { verticals } = require('app/scripts/views/onboarding/constants');
const Language = require('@trello/locale');
const {
  getSavedInspirationBoards,
  isInspirationBoard,
  getVertical,
  saveBoard,
  removeBoard,
} = require('app/scripts/views/onboarding/storage');

const getLocale = function () {
  const lowerCaseLocale = Language.currentLocale.toLowerCase();
  const localeCode = (() => {
    switch (false) {
      case lowerCaseLocale !== 'zh-tw':
        return 'zh-hant';
      case lowerCaseLocale !== 'zh-cn':
        return 'zh-hans';
      case lowerCaseLocale !== 'zh-hant':
        return 'zh-hant';
      case lowerCaseLocale !== 'zh-hans':
        return 'zh-hans';
      case lowerCaseLocale !== 'pt-br':
        return 'pt-br';
      default:
        return lowerCaseLocale.split('-')[0];
    }
  })();

  return localeCode;
};

const getTranslatedFile = function (fileMap, locale) {
  const localeCode = getLocale();
  const fileKeys = Object.keys(fileMap);
  if (fileKeys.includes(localeCode)) {
    return fileMap[localeCode];
  }
  return fileMap['en'];
};

const getBoardDataForVertical = (vertical) =>
  verticals[vertical].inspirationBoards[getLocale()];

const copyBoardFromVertical = (modelCache, vertical) => {
  return new Promise((resolve, reject) => {
    let { id } = getBoardDataForVertical(vertical);
    const { name } = getBoardDataForVertical(vertical);

    const initialData = {
      name,
      idOrganization: '',
    };

    const requestData = _.extend(initialData, {
      creationMethod: 'assisted',
      idBoardSource: id,
      keepFromSource: 'cards',
      prefs_permissionLevel: 'private',
    });

    return Auth.me().boardList.create(initialData, {
      modelCache,
      requestData,
      success: (board) => {
        let currentBoards, needle;
        saveBoard(id, board.id);

        if (
          ((needle = board.id),
          !Array.from((currentBoards = Auth.me().get('idBoards'))).includes(
            needle,
          ))
        ) {
          Auth.me().set('idBoards', currentBoards.concat(board.id));
        }

        // Remove other inspiration boards from local storage and close them
        const object = getSavedInspirationBoards();
        for (const inspoBoardId in object) {
          const myBoardId = object[inspoBoardId];
          if (myBoardId !== board.id) {
            // Coffescript binding issue here. If we dont reset this, the callback
            // will use the next id in the for loop
            id = myBoardId;
            __guard__(ModelCache.get('Board', id), (x) =>
              x.close(() => removeBoard(id), false),
            );
          }
        }

        return resolve(board);
      },
      error(err) {
        return reject(err);
      },
    });
  });
};

module.exports = {
  copyBoardFromVertical,
  isInspirationBoard,
  getVertical,
  getBoardDataForVertical,
  removeBoard,
  getLocale,
  getTranslatedFile,
  saveBoard,
};

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}
